import {BaseActionButton} from './BaseActionButton';

class Redo extends BaseActionButton {
  icon = 'redo';
  tooltip = 'Redo';

  disabled = () => {
    return !this.rackEditorStore.rackStore.changes.canRedo;
  };

  onClick = () => {
    const {rackStore, selection} = this.rackEditorStore;
    this.hidePopups(true, true);
    selection.select(...rackStore.redo());
  };
}

export {Redo};
